
export const navMenuItems = [
    {
      url: "/member",
      name: "회원관리",
      slug: "회원관리",
      icon: "FileIcon",
      submenu : [
        {
          url: "/member",
          name: "사용자목록",
          slug: "member",
          icon: "user",
        },
        {
            url: "/advancepayment",
            name: "선급계약목록",
            slug: "advance",
            icon: "advance",
        },
      ]
    },
    {
        url: "/artist",
        name: "음원관리",
        slug: "artist",
        icon: "FileIcon",
        submenu : [
            {
                url: "/artist",
                name: "아티스트목록",
                slug: "artist",
                icon: "artist",
            },
            {
                url: "/album",
                name: "앨범목록",
                slug: "album",
                icon: "album",
            },
            // {
            //     url: "/track",
            //     name: "트랙조회",
            //     slug: "/track",
            //     icon: "track",
            // },
            {
                url: "/genre",
                name: "장르조회",
                slug: "/genre",
                icon: "advance",
            },
            
            {
                url: "/calendar",
                name: "캘린더",
                slug: "calendar",
                icon: "calendar",
            },
            {
                url: "/transfer",
                name: "내부이관",
                slug: "transfer",
                icon: "advance",
            },
        ]
    },
    {
        name: "코드 관리",
        slug: "code-management",
        icon: "FileIcon",
        submenu: [
            {
                url: "/code-generation/prefix-status",
                name: "GS1 Prefix 현황",
                slug: "code-generation-prefix-status",
                icon: "advance",
            },
            {
                url: "/code-generation-export",
                name: "GS1 바코드 내보내기",
                slug: "code-generation-export",
                icon: "advance",
            },
            {
                url: "/code-generation/isrc-prefix-status",
                name: "ISRC Prefix 현황",
                slug: "code-generation-isrc-prefix-status",
                icon: "advance",
            },
        ]
    },
    {
        url: "/ddex",
        name: "Delivery Job (DJ)",
        slug: "ddex",
        icon: "FileIcon",
        submenu : [
            {
                url: "/ddex/job",
                name: "Job 목록",
                slug: "ddex/job",
                icon: "advance",
            },
            {
                url: "/export-preset",
                name: "DSP Group 관리",
                slug: "export-preset",
                icon: "advance",
            },
            {
                url: "/album-delivery-tracker",
                name: "해외 앨범 유통 현황",
                slug: "album-delivery-tracker",
                icon: "advance",
            },
        ]
    },
    {
        name: "YouTube Content ID",
        slug: "youtube-cid",
        icon: "FileIcon",
        submenu: [
            {
                url: "/youtube-cid",
                name: "검색",
                slug: "youtube-cid-search",
                icon: "advance",
            },
            {
                url: "/youtube-cid/whitelists",
                name: "허용 목록",
                slug: "youtube-cid-whitelists",
                icon: "advance",
            },
        ]
    },
    {
        name: "정산관리",
        slug: "정산관리",
        icon: "musicstore",
        submenu : [
           
            {
                url: "/dataUpload",
                name: "업로드/데이터 검수",
                slug: "dataUpload",
                icon: "data1",
            },
            {
                url: "/dataExchange",
                name: "환전 처리 결과",
                slug: "dataExchange",
                icon: "settlement",
            },
            {
                url: "/dataOpen",
                name: "공개 처리 결과",
                slug: "dataOpen",
                icon: "musicstore",
            },
            {
                url: "/royalty-reporting",
                name: "정산 공개일 관리",
                slug: "royalty-reporting",
                icon: "settlement",
            },
            {
                url: "/settlement",
                name: "정산내역",
                slug: "정산내역",
                icon: "settlement",
            },
            {
                url: "/taxinvoice",
                name: "정산세계발행",
                slug: "정산세계발행",
                icon: "advance",
            },
            {
                url: "/aggregator",
                name: "계약사 목록",
                slug: "계약사 목록",
                icon: "musicstore",
            },
            {
                url: "/musicstore",
                name: "뮤직스토어 목록",
                slug: "뮤직스토어 목록",
                icon: "musicstore",
            }
        ]
    },
    {
        url: "/transaction",
        name: "지급관리",
        slug: "지급관리",
        icon: "FileIcon",
        submenu : [
            {
                url: "/withdrawal",
                name: "출금신청내역",
                slug: "출금신청내역",
                icon: "withdrawal",
            },
            {
                url: "/transaction",
                name: "거래내역",
                slug: "거래내역",
                icon: "transition",
            }
        ]
    },
    {
        url: "/support/notice",
        name: "고객센터",
        slug: "고객센터",
        icon: "FileIcon",
        submenu : [
            {
                url: "/support/notice",
                name: "공지사항",
                slug: "공지사항",
                icon: "advance",
            },
            {
                url: "/support/faq",
                name: "FAQ",
                slug: "FAQ",
                icon: "advance",
            },
            {
                url: "/support/inquiry",
                name: "1:1문의",
                slug: "1:1문의",
                icon: "advance",
            }
        ]
    },
    {
        name: "BlackList",
        slug: "blacklist",
        icon: "FileIcon",
        submenu: [
            {
                url: "/ddex/blacklabel",
                name: "BlackList 기획사",
                slug: "ddex/blacklabel",
                icon: "advance",
            },
            {
                url: "/ddex/blackgenre",
                name: "BlackList 장르",
                slug: "ddex/blackgenre",
                icon: "advance",
            },
            {
                url: "/ddex/blackartist",
                name: "BlackList 아티스트",
                slug: "ddex/blackartist",
                icon: "advance",
            },
        ]
    },
    // {
    //     url: "/statistics",
    //     name: "통계",
    //     slug: "통계",
    //     icon: "user_statistics",
    //     submenu : [
    //         {
    //             url: "/statistics_user",
    //             name: "권리자 통계",
    //             slug: "권리자 통계",
    //             icon: "user_statistics",
    //         },
    //         {
    //             url: "/statistics_admin",
    //             name: "관리자 통계",
    //             slug: "관리자 통계",
    //             icon: "admin_statistics",
    //         }
    //     ]
    // },
    // {
    //     url: "/member/admin",
    //     name: "관리자목록",
    //     slug: "관리자목록",
    //     icon: "admin",
    // }

  ]

// 검색 및 즐겨찾기시
/* eslint-disable */
export const navbarSearchAndPinList =  {
    pages: {
        key: "name",
        data: [
            // {title: '사용자목록', url: '/member', icon: 'FileIcon', is_bookmarked: false},
            {
                url: "/member",
                name: "사용자목록",
                icon: "user",
                is_bookmarked: false
            },
            {
                url: "/artist",
                name: "아티스트목록",
                slug: "artist",
                icon: "artist",
                is_bookmarked: false
            },
            {
                url: "/album",
                name: "앨범목록",
                slug: "album",
                icon: "album",
                is_bookmarked: false
            },
            // {
            //     url: "/track",
            //     name: "트랙조회",
            //     slug: "/track",
            //     icon: "track",
            //     is_bookmarked: false
            // },
            {
                url: "/dataUpload",
                name: "업로드/데이터 검수",
                slug: "업로드/데이터 검수",
                icon: "data1",
                is_bookmarked: false
            },
            {
                url: "/dataExchange",
                name: "환전 처리 결과",
                slug: "환전 처리 결과",
                icon: "settlement",
                is_bookmarked: false
            },
            {
                url: "/dataOpen",
                name: "공개 처리 결과",
                slug: "공개 처리 결과",
                icon: "musicstore",
                is_bookmarked: false
            },
            {
                url: "/settlement",
                name: "정산내역",
                slug: "정산내역",
                icon: "settlement",
                is_bookmarked: false
            },
            {
                url: "/taxinvoice",
                name: "정산세계발행",
                slug: "정산세계발행",
                icon: "advance",
            },
            {
                url: "/aggregator",
                name: "계약사 목록",
                slug: "계약사 목록",
                icon: "musicstore",
            },
            {
                url: "/calendar",
                name: "캘린더",
                slug: "calendar",
                icon: "calendar",
                is_bookmarked: false
            },

            {
                url: "/withdrawal",
                name: "출금신청내역",
                slug: "출금신청내역",
                icon: "withdrawal",
                is_bookmarked: false
            },
            {
                url: "/transaction",
                name: "거래내역",
                slug: "거래내역",
                icon: "transition",
                is_bookmarked: false
            }
        ]
    }
}


  /* eslint-enable */
  